// extracted by mini-css-extract-plugin
export default {"products":"su-z","card":"tu-z","oosMessaging":"uu-z"};